export default class PinturaImageEditorResult{
    constructor() {
        this.newFile = null;
        this.deletedFile = null;
        this.replace = false;
    }

}